import BaseModel from './BaseModel';

class RentalCustomer extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.customer_nomenclature = data.cus_nomenclature_id
    this.name = data.name
    this.security_left = data.wallet_balance
    if (data.user_kyc?.status == 'kyc_validated') {
      this.onboarding_date_time = data.onboarding_date_time
      this.bookings_count = data.rental_bookings_count
    }
    this.mobile_number = data.mobile_number
    this.gender = data.gender
    this.date_of_birth = data.dob
  }
}

export default RentalCustomer;
